import { PoweroffOutlined, ReloadOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Col, Row, Tooltip } from 'antd';
import { reloadDeviceConfig, stopScannerServer } from '../../utils/device_utils';
import React, { Component } from 'react';

class ReloadConfigPrompt extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    handleOnClick = (e, callback, resetIgnore) => {
        e.stopPropagation(); 
        callback(this.props.device.id);
        this.props.closePromptHook(resetIgnore)
    }

    render() {
        return (
                <div className="rounded-container config-reload-message" style={{height: '300px'}}>
                    <Col span={24}>
                        <Row style={{ fontSize: 20 }} className="arial-font">
                        Scanner config has changed in the the background.<br></br> Please reload the config for latest results.
                        </Row>
                        <br></br>
                        <br></br>
                        <Row style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', color: 'black', fontSize: 14}}>
                            <Tooltip title="Click here to reload device config" placement="rightTop">
                                <Col span={3} className="promt-done-button" onClick={(e) => {this.handleOnClick(e, reloadDeviceConfig, true)}}>
                                    <Row style={{ color: "#26A65B", marginBottom: 3}}>
                                        <ReloadOutlined style={{ fontSize: 35 }}/>
                                    </Row>
                                    <Row className="arial-font">Reload</Row>
                                </Col>
                            </Tooltip>
                            <Tooltip title="Click here to ignore this change" placement="rightTop">
                                <Col span={3} className="promt-done-button" onClick={(e) => {this.handleOnClick(e, this.props.ignorePromptHook, false)}}>
                                    <Row style={{ color: "#F7B500", marginBottom: 3}}>
                                        <ExclamationCircleOutlined style={{ fontSize: 35 }}/>
                                    </Row>
                                    <Row className="arial-font">Ignore</Row>
                                </Col>
                            </Tooltip>
                            <Tooltip title="Click here to shutdown the scanner" placement="rightTop">
                                <Col span={3} className="promt-done-button" onClick={(e) => {this.handleOnClick(e, stopScannerServer, true)}}>
                                    <Row style={{ color: "#FF0000", marginBottom: 3 }}>
                                        <PoweroffOutlined style={{ fontSize: 35 }}/>
                                    </Row>
                                    <Row className="arial-font">Shutdown</Row>
                                </Col>
                            </Tooltip>
                        </Row>
                    </Col>
                </div>
        )
    }
}

export default ReloadConfigPrompt;